export function NotFoundPageV2() {
  return <></>;
}
